import { createFileRoute } from "@tanstack/react-router";
import useAppStore from "@/store";
import { useEffect } from "react";

export const Route = createFileRoute('/(onboarding)/auth/logout')({
  component: Logout,
});

function Logout() {
  const store = useAppStore();
  useEffect(() => {
    store.auth.logout();
  }, []);
  return <></>;
}